import { render, staticRenderFns } from "./Load_img.vue?vue&type=template&id=3df3888c&scoped=true&"
import script from "./Load_img.vue?vue&type=script&lang=js&"
export * from "./Load_img.vue?vue&type=script&lang=js&"
import style0 from "./Load_img.vue?vue&type=style&index=0&id=3df3888c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df3888c",
  null
  
)

export default component.exports